import React from 'react';
import styled from 'styled-components';

import reference from '../copy/reference.yml';
import color from '../styles/color';

const Section = styled.section`
  max-width: 500px;
  margin: 40px auto;
  padding: 5px 10px;

  & li {
    margin: 5px 0 5px 1em;
  }

  & div {
    font-size: 12px;
  }

  & h3 {
    font-size: 24px;
    margin: 10px 0;
  }

  & a,
  & a:visited,
  & a:link {
    word-wrap: break-word;
    text-decoration: none;
    color: ${color.ippdDarker};
    border-bottom: 1px dotted ${color.ippdDarker};
  }
`;

const Reference = () => {
  return (
    <Section>
      <h3>อ้างอิง</h3>
      <ul>
        {reference.map(({ title, type, url }) => (
          <li key={title}>
            <div>{title}</div>
            <div>
              <a href={url}>{url}</a>
            </div>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default Reference;
